<template>
    <span
      :class="['font-awesome-cell', variant, canClick ? 'clickable' : null]"
      @click="canClick ? clickHandler(value) : null"
    >
      <font-awesome-icon v-if="icon" :icon="icon" :spin="spin" />
      <span class="text" v-if="text">{{ text }}</span>
    </span>
</template>
<script>
import _ from 'lodash'

export default {
  name: 'FontAwesomeCellRenderer',
  computed: {
    value () {
      return this.params.valueFormatted || this.params.value
    },
    icon () {
      const params = this.params
      const value = this.value
      if (value?.icon) return value.icon
      if (params?.value === true && params.trueIcon) return params.trueIcon
      if (params?.value === false && params.falseIcon) return params.falseIcon
      if (params.icon) return params.icon
      if (params.valueIcons) return params.valueIcons[value]
      return null
    },
    text () {
      return this.value?.text
    },
    spin () {
      return this.value?.spin
    },
    variant () {
      return this.value?.variant
    },
    clickHandler () {
      return this.params.clickHandler
    },
    clickDisabled () {
      return !!this.value.clickDisabled
    },
    canClick () {
      return !!this.clickHandler && !this.clickDisabled
    }
  }
}
</script>
<style>
.font-awesome-cell{
  &.clickable {
    cursor: pointer;
  }

  &.error {
    color: var(--flat-ui-alizarin);
  }
  &.warning {
    color: var(--flat-ui-sunflower);
  }
  &.success {
    color: var(--flat-ui-emerald);
  }
  &.info {
    color: var(--flat-ui-peter-river);
  }
  &.waiting {
    color: var(--fc-logo-orange);
  }

  .text {
    margin-left: .5rem;
  }
}

</style>
